import React from 'react';
import { resolveContentKindLabel, resolveContentKindToken } from '../helpers';

type Props = {
  content: any;
  className?: string;
};

export default function ContentKindBadge({ content, className = '' }: Props) {
  const label = resolveContentKindLabel(content);
  const token = resolveContentKindToken(content) || 'conteudo';

  return (
    <span
      className={`content-view__kind content-view__kind--${token} ${className}`.trim()}
      aria-label={`Tipo de conteúdo: ${label}`}
    >
      {label}
    </span>
  );
}
